/**
 * Auto-generated from SVG file. Do not edit manually.
 * Original: images/icons/copy.svg
 */
import React from 'react';

export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    {...props}
  >
    <path d="M710 10H360c-38.6 0-70 31.4-70 70v630c0 38.6 31.4 70 70 70h490c38.6 0 70-31.4 70-70V220L710 10zm0 99 111 111H710V109zm140 601H360V80h280v210h210v420z"/><path d="M430 360h350v70H430v-70zm0 140h350v70H430v-70z"/><path d="M640 920H150V290h70v-70h-70c-38.6 0-70 31.4-70 70v630c0 38.6 31.4 70 70 70h490c38.6 0 70-31.4 70-70v-70h-70v70z"/>
  </svg>
);
